import { Injectable } from '@angular/core';
import { LoginService } from '../login/login.service';
import { PatientService } from '../patient/patient.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentAccessControlService {

  constructor(
    private _login: LoginService,
    private _patientSrv: PatientService
  ) {}

  /**
   * Vérifie si l'utilisateur peut modifier le statut privé d'un document
   * Seul le médecin responsable du dossier patient et le créateur du doc peuvent le faire
   * @param patientId - L'ID du patient
   * @returns true si l'utilisateur peut modifier le statut, false sinon
   */
  async canModifyPrivateStatus(patientId: string, authorId?: string): Promise<boolean> {
    const currentUser = this._login.getCurrentProfil();
    
    if (authorId && authorId === currentUser.id) {
      return true;
    }

    const patient = await this._patientSrv.findOnePatientInfos(patientId);
    
    return patient?.idResponsable === currentUser.id;
  }
}
